// extracted by mini-css-extract-plugin
module.exports = {"counters":"AboutCounters_counters__6eLBz","counter":"AboutCounters_counter__mpelX","subtext":"AboutCounters_subtext__5VsRr"};